export default function dateOfBirth (string, locale) {
  if (string.match(/^(19|20|21)\d{2}-[0-1][0-9]-[0-3][0-9]$/)) {
    const timezoneOffset = new Date().getTimezoneOffset()
    const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60))
    const timezoneOffsetMinutes = Math.abs(timezoneOffset % 60)
    const timezoneOffsetString = (timezoneOffset < 0 ? '-' : '') +
      (timezoneOffsetHours < 10 ? '0' + timezoneOffsetHours : timezoneOffsetHours).toString() +
      ':' +
      (timezoneOffsetMinutes < 10 ? '0' + timezoneOffsetMinutes : timezoneOffsetMinutes).toString()
    return new Date(string + 'T00:00:00.000' + timezoneOffsetString).toLocaleDateString(locale)
  } else {
    return ''
  }
}
